import * as React from "react";
import type { SVGProps } from "react";
const SvgSafetyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="safety_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="m549.547 919.637-38.528 19.03-38.059-19.84-14.25-7.296c-71.851-36.822-214.571-109.867-307.585-264.875-31.488-52.523-46.378-123.733-54.485-186.368-8.49-65.493-10.965-134.144-11.307-189.184a101.632 101.632 0 0 1 76.544-98.73L480.94 89.258a123.307 123.307 0 0 1 62.122 0l319.062 83.114a101.547 101.547 0 0 1 76.544 98.944c-.982 106.368-12.459 262.144-58.368 366.208-77.654 176.043-225.152 237.483-300.459 268.843-12.203 5.12-22.528 9.387-30.293 13.227zM485.248 648.15l249.301-255.701a42.667 42.667 0 1 0-61.098-59.563L453.29 558.677l-103.85-98.901a42.667 42.667 0 1 0-58.88 61.781L424.661 649.26c17.067 16.298 44.118 15.786 60.587-1.11z"
    />
  </svg>
);
export default SvgSafetyIcon;
